<template>
<div class="min-h-screen flex flex-col py-6 bg-gray-50 sm:px-6 sm:py-12 lg:px-8">

  <div class="pt-12 sm:mx-auto sm:w-full sm:max-w-md lg:pt-16">
    <transition name="fade" mode="out-in">
      <div v-if="!isLoading" key="content" class="bg-white pb-8 px-4 shadow sm:rounded-lg sm:px-10">


        <!-- TUTOR INFO -->
      
        <div class="flex justify-center">
          <img :src="tutor.Photo" class="-mt-12 h-24 w-24 lg:-mt-16 lg:h-32 lg:w-32 rounded-full" alt=""  @click="$refs.amount.focus()" />
        </div>

        <h1 class="mt-6 mx-auto max-w-xs text-lg text-gray-700 font-semibold text-center">
          {{ tutor.Name }} does not have online{{'\xa0'}}payments{{'\xa0'}}enabled.
        </h1>
        <p class="mt-4 mx-auto max-w-xs text-sm text-gray-500 text-center">
          Please contact them directly to have them enable online payments or suggest alternative methods of payment.
        </p>

        <div class="mt-6 text-center">
          <TailwindButton
            @click="$router.push({ name: 'Tutor', params: { id: $route.params.id, stub: $route.params.stub } })"
          >
            Visit Profile
          </TailwindButton>
        </div>

      </div>
      <div v-else key="loading" class="h-60 bg-gray-200 animate-pulse sm:rounded-lg">
        <!-- Loading -->
      </div>
    </transition>
  </div>
  
  <div class="mt-6 mx-auto px-4 w-full flex justify-between items-center sm:px-0 sm:max-w-md">
    <router-link :to="{ name: 'Home' }">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index" class="h-3" />
    </router-link>
    <div class="flex items-center">
      <span class="text-xs text-gray-500">Secured by</span>
      <img src="../assets/stripe-wordmark-slate.svg" alt="Stripe" class="mt-px h-5 opacity-60" />
    </div>
  </div>

</div>
</template>

<script>
import TutorService from '@/services/TutorServices'
import TailwindButton from './TailwindButton.vue'
const tutorService = new TutorService()

export default {
  components: { TailwindButton },
  data() {
    return {
      tutor: {},
      isLoading: true,
    }
  },
  async mounted() {
    
    const [tutorResponse, acceptsPaymentResponse] = await Promise.all([
      tutorService.get(this.$route.params.id),
      tutorService.canAcceptPayments(this.$route.params.id),
    ])

    if (acceptsPaymentResponse.data) {
      this.$router.push({ name: 'PayTutor', params: this.$route.params })
      return
    }

    this.tutor = tutorResponse.data

    this.isLoading = false
  }
}
</script>

<style>

</style>